<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-grid" />Faq
      </slot>
      <div class="float-right">
        <router-link :to="{ name: 'FaqCreate'}">
          <button class="btn btn-success">Create New Faq</button>
        </router-link>
      </div>
    </CCardHeader>
    <CCardBody>
      <v-client-table :data="faqs" :columns="columns" :options="options">
        <template slot="action" slot-scope="props">
          <div>
            <router-link :to="{ name: 'FaqEdit', params: {id: props.row.id}}">
              <span
                  class="btn btn-warning btn-sm m-1"
                  data-toggle="tooltip"
                  title="Edit"
                  :href="props.row.id"
              >
                <CIcon name="cil-pencil" size="sm" />
              </span>
            </router-link>
            <span @click="handleDelete(props.row.id)"
                  class="btn btn-danger btn-sm m-1"
                  data-toggle="tooltip"
                  title="Delete"
                  :href="props.row.id"
            >
                <CIcon name="cil-basket" size="sm" />
              </span>
          </div>
        </template>
      </v-client-table>
    </CCardBody>
  </CCard>
</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
export default {
  name: "Faqs",
  data() {
    return {
      faqs: [],
      columns: ["id", "question", "answer", "created_at","action"],
      options: {
        pagination: { nav: "fixed" },
        filterByColumn: true,
        toMomentFormat: "YYYY-MM-DD",
        sortIcon: {
          base: "fa fa-sort",
          up: "fa fa-sort-up",
          down: "fa fa-sort-down",
          is: "fa fa-sort",
        },
      },
    };
  },
  created() {
    this.getfaqs();
  },
  methods: {
    getfaqs() {
      this.$axios
          .get(`${ADMIN_URL}/faqs`)
          .then((response) => {
            console.log("faqs, response === ", response.data);
            this.faqs = response.data.data;
          })
          .catch((e) => {
            console.log("error occurs", e);
          });
    },
    handleDelete(id) {
      // console.log('handleDelete  category_id === ', category_id);
      this.$swal({
        title: 'Are you sure?',
        type: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
      }).then(result => {
        if(result.value) {
          this.deleteFaqs(id);
        }
      }).catch(error => {
        //console.log('Sweetalert ERROR');
      });
    },
    deleteFaqs(id)
    {
      this.$axios
          .delete(`${ADMIN_URL}/faqs/${id}`)
          .then((response) => {
            this.$swal("Success", response.data.message, "success");
            this.getfaqs()
          })
          .catch((error) => {
            console.log("Error  ... ", error.response);
            this.$swal("Error", error.response.message, "error");
          });
    }
  },
};
</script>


